import PageWrapper from 'components/utils/PageWrapper';
import ForwardItem from 'pages/ForwardItem';

export const forwardItemRoutes = {
    path: '/forward-item/:forwardItemId',
    element: (
        <PageWrapper titleId="forward_curve_item_title">
            <ForwardItem />
        </PageWrapper>
    ),
};
